exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-form-page[data-v-a1cb79d8]{padding:50px 30px;max-width:1080px}.activity-form-page[data-v-a1cb79d8] .el-table--small td{padding:4px 0}.activity-form-page .image-uploader-icon[data-v-a1cb79d8]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px;border-color:#409EFF}.activity-form-page .image-tips[data-v-a1cb79d8]{color:#F56C6C;font-size:12px}\n", ""]);

// exports
